"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(func, wait, immediate) {
    var timeout = null;
    return function () {
        var later = function () {
            timeout = null;
            if (!immediate)
                func();
        };
        var callNow = immediate && !timeout;
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func();
    };
}
exports.default = default_1;
